import React from "react"
import styled from "styled-components"
import { Tabs } from "antd";

import container from "container/BrokerDashboard/globalPagesContainer"
import agentSearchContainer from "container/BrokerDashboard/agentSearchContainer"
import accounSearchContainer from "container/BrokerDashboard/accountSearchContainer"
import teamContainer from "container/BrokerDashboard/teamContainer.js"
import { formatPriceOverviewValues } from "../AgentDashboard/Util";

const OuterWrap = styled.div`
  padding: 20px 73px 0px 73px;
`

const BorderWrap = styled.div`
  border: 1px solid #e5e7eb;
  border-radius: 14px;
`;

const OverViewHeader=styled.div`
padding:20px 24px 19px 24px;
display:flex;
flex-direction:row;
justify-content:space-between;
`
const OverViewCards=styled.div`
margin:24px;
margin-top:16px;
display:grid;
grid-template-columns:repeat(5,1fr);
justify-content:space-between;
gap:36.6px;
`
const Card=styled.div`
border: 1px solid #E5E7EB;
border-radius:8px;
padding:24px;
height:134px;
`

const StyledTabs = styled(Tabs)`
  .ant-tabs-nav {
    padding-top:12px;
    padding-bottom:12px;
  }
  .ant-tabs-tab {
    font-size: 14px;
    font-weight: 500;
    color: #1f2937;
    padding: 8px 24px;
  }
 
  .ant-tabs-tab-active {
    color: #6366f1;
    background: #EEF2FF;
    border-bottom: 2px solid #4F46E5;
  }
     .ant-tabs-tab + .ant-tabs-tab {
    margin-left: 0;
  }

  .ant-tabs-tab:hover {
    background: #EEF2FF;
  }
`;
const MetricCard = ({ label, value }) => (
  <Card>
    <p style={{fontWeight:500, fontSize:"16px", color:"#6B7280",lineHeight:"19.36px"}}>
      {label}
    </p>
    <p style={{fontWeight:600, fontSize:"36px", lineHeight:"44px"}}>
      {value}
      </p>
  </Card>
);


const NewRoster = ({overview,activeTab}) => {

return (
  <OuterWrap>
     {true && overview && <BorderWrap>
   <OverViewHeader>
        <p style={{ fontWeight: "500px", fontSize: "18px" }}>Overview</p>
       
      </OverViewHeader>
      <OverViewCards>
      {activeTab==="2" && <MetricCard 
      label="Total Agents" 
      value={overview?.total_agents || 0} 
    />}
        {activeTab!=="2" && <MetricCard 
      label="Total Accounts" 
      value={overview?.total_accounts || 0} 
    />}
        {activeTab!=="3" && <MetricCard 
      label="Closed Deals" 
      value={overview?.total_deals || overview?.total_deals_closed || 0}
    />}
        {activeTab!=="3" && <MetricCard 
      label="In-Contract Deals"
      value={overview?.total_in_contracts || 0}
    />}
        {activeTab!=="3" && <MetricCard 
      label="Total Price" 
      value={formatPriceOverviewValues(overview?.total_price) || formatPriceOverviewValues(overview?.total_production) || 0} 
    />}
        {activeTab!=="3" && <MetricCard 
      label="Total Radius Fees" 
      value={formatPriceOverviewValues(overview?.total_radius_fees) || 0} 
    />}
        {activeTab!=="3" &&<MetricCard 
      label="Total Gross Commission" 
      value={formatPriceOverviewValues(overview?.total_gross_commission) || 0}
    />}
     {activeTab!=="3" &&<MetricCard 
      label="Total Agent Commission" 
      value={formatPriceOverviewValues(overview?.total_agent_commission) || 0}
    />}
    {activeTab!=="3" &&<MetricCard 
      label="Average Annual Gross Commission" 
      value={formatPriceOverviewValues(overview?.average_annual_gross_commission) || 0}
    />}
    {activeTab!=="3" &&<MetricCard 
      label="Last 12 Months Production" 
      value={formatPriceOverviewValues(overview?.total_past_volume) || formatPriceOverviewValues(overview?.last_12_months_production) || 0}
    />}
      </OverViewCards>
    </BorderWrap>}

    

  </OuterWrap>

);
}
export default teamContainer(agentSearchContainer(container(NewRoster)))